import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/** Folder object returned per lesson from `courses/<id>/create-lessons/`. */
export interface CreateLessonsFolder {
  folder_id: string;
  folder_name: string;
  full_path: string;
  s3_url: string;
  s3_key: string;
}

/** Single lesson row in the API `data` array. */
export interface CreateLessonsLessonRow {
  name: string;
  start_date: string;
  end_date: string | null;
  description: string;
  course: number;
  status: number;
  is_personalize: boolean;
  is_file_download: boolean;
  lesson_preview: boolean;
  virtual_assistant: boolean;
  push_to_schoology: boolean;
  user_query: { question: string };
  ai_answer: { answer: string };
  teacher: number;
  lesson_id: string;
  folder: CreateLessonsFolder;
}

export interface CreateLessonsSuccessPayload {
  success: boolean;
  message: string | null;
  courseId: number | null;
  courseName: string | null;
  lessonsCreated: number | null;
  lessons: CreateLessonsLessonRow[] | null;
}

export interface CreateLessonsState {
  isLoading: boolean;
  error: string | null;
  success: boolean;
  message: string | null;
  courseId: number | null;
  courseName: string | null;
  lessonsCreated: number | null;
  lessons: CreateLessonsLessonRow[] | null;
}

const initialState: CreateLessonsState = {
  isLoading: false,
  error: null,
  success: false,
  message: null,
  courseId: null,
  courseName: null,
  lessonsCreated: null,
  lessons: null,
};

const createLessonsSlice = createSlice({
  name: "createLessons",
  initialState,
  reducers: {
    setcreateLessonsSuccess: (
      state,
      action: PayloadAction<CreateLessonsSuccessPayload>,
    ) => {
      state.success = action.payload.success;
      state.message = action.payload.message;
      state.courseId = action.payload.courseId;
      state.courseName = action.payload.courseName;
      state.lessonsCreated = action.payload.lessonsCreated;
      state.lessons = action.payload.lessons;
      state.isLoading = false;
      state.error = null;
    },
    setloading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    seterror: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
      state.success = false;
      state.message = null;
      state.courseId = null;
      state.courseName = null;
      state.lessonsCreated = null;
      state.lessons = null;
    },
    resetcreateLessonsStatus: () => initialState,
  },
});

export const {
  setcreateLessonsSuccess,
  setloading,
  seterror,
  resetcreateLessonsStatus,
} = createLessonsSlice.actions;

export default createLessonsSlice.reducer;
